import { client, noAuth } from './client'
import { createResponse } from '../response'
import { createUserActivityResponse } from './normalize'
import { USER_ACTIVITY_BATCH_SIZE } from '@/utils/constants'

const createUser = async (userRequest) => {
  try {
    let response = await noAuth.post('/v2/users', userRequest)
    return response.data
  } catch (error) {
    throw error
  }
}

const authenticateUser = async (number, pin, voucher = null) => {
  try {
    let response = await noAuth.post(`/v2/users/number/${number}/authentication`, {
      password: pin,
      voucher: voucher
    })
    return response.data
  } catch (error) {
    throw error
  }
}

const forgotPin = async (number, reset_type = 'sms') => {
  try {
    let response = await noAuth.post(`/v1/users/number/${number}/password/forgot`, {
      option: reset_type,
      template: {
        id: 226,
        parameters: {
          url: process.env.MY_URL + '/password/reset'
        }
      }
    })
    return response.data
  } catch (error) {
    throw error
  }
}

const fetchUserAccount = async () => {
  try {
    let response = await client.get('/v2/account/user/accounts/calling')
    return createResponse(response.data.account.buckets)
  } catch (error) {
    throw error
  }
}

const fetchUserPaymentCount = async () => {
  try {
    let response = await client.get('/v2/account/user/accounts')
    return response.data.accounts[0].user.paymentCount
  } catch (error) {
    throw error
  }
}

const updateCurrency = async (user) => {
  try {
    let response = await client.delete('/v1/account/vatnumber/', { data: null })
    return response.data
  } catch (error) {
    throw error
  }
}

const fetchUserActivity = async (latestSequenceNumber) => {
  let batchSize = USER_ACTIVITY_BATCH_SIZE
  let resource = latestSequenceNumber ? `/v1/userfeed/all/${batchSize}/${latestSequenceNumber}` : `/v1/userfeed/all/${batchSize}`
  try {
    let response = await client.get(resource)
    return createUserActivityResponse(response.data)
  } catch (error) {
    throw error
  }
}

const fetchUserfeedExportFile = async () => {
  try {
    let response = await client.get('/v1/userfeed/download')
    return response.data
  } catch (error) {
    throw error
  }
}

const exportUserfeed = async () => {
  try {
    let response = await client.get('/v1/userfeed/export/pdf')
    return response.data
  } catch (error) {
    throw error
  }
}

const cancelAccount = async (cancelAccountRequest) => {
  try {
    await client.delete('/v1/user', {
      data: {
        'reasonId': cancelAccountRequest.reasonId,
        'comment': cancelAccountRequest.comment,
        'pin': cancelAccountRequest.pin
      }
    })
  } catch (error) {
    throw error
  }
}

const fetchReferralInfo = async (code, currencyId) => {
  try {
    let response = await client.get('/v1/referral/user', {
      params: {
        code: code,
        currencyId: currencyId
      }
    })
    return response.data
  } catch (error) {
    throw error
  }
}

const fetchNumbers = async () => {
  try {
    let response = await client.get('/v2/user/numbers/true')
    return createResponse(response.data)
  } catch (error) {
    throw error
  }
}

const fetchIdentities = async (number) => {
  try {
    let response = await client.get('/v1/user/identities')
    return response.data
  } catch (error) {
    throw error
  }
}

const setPrimiaryNumber = async (endpoint) => {
  try {
    let response = await client.put('/v1/user/identities/number/' + endpoint, {
      primary: true
    })
    return createResponse(response.data)
  } catch (error) {
    throw error
  }
}

const saveNumber = async (type, endpoint) => {
  try {
    let response = await client.post('/v2/user/numbers/', {
      type: type,
      endpoint: endpoint
    })
    return createResponse(response.data)
  } catch (error) {
    throw error
  }
}

const deleteNumber = async (endpoint) => {
  try {
    let response = await client.delete('/v2/user/numbers/' + endpoint, {
      data: {
        endpoint: endpoint
      }
    })
    return createResponse(response.data)
  } catch (error) {
    throw error
  }
}

const addNumber = async (endpoint) => {
  try {
    let response = await client.post('/v2/user/numbers/', {
      endpoint: endpoint,
      type: 'number'
    })
    return createResponse(response.data)
  } catch (error) {
    throw error
  }
}

const verifyNumberBySMS = async (endpoint) => {
  try {
    let response = await client.post('/v1/identityverification/', {
      identity: {
        type: 'number',
        endpoint: endpoint
      },
      code: '',
      option: 'sms'
    })
    return createResponse(response.data)
  } catch (error) {
    throw error
  }
}

const verifyNumberByCall = async (endpoint) => {
  try {
    let response = await client.post('/v1/identityverification/', {
      identity: {
        type: 'number',
        endpoint: endpoint
      },
      option: 'callout'
    })
    return createResponse(response.data)
  } catch (error) {
    throw error
  }
}

const verifyNumberWithRecivedCode = async (data) => {
  try {
    let response = await client.put('/v1/identityverification/', {
      identity: {
        type: 'number',
        endpoint: data.endpoint
      },
      option: 'sms',
      code: data.code,
      id: ''
    })
    return createResponse(response.data)
  } catch (error) {
    throw error
  }
}

const fetchUserServices = async () => {
  try {
    let response = await client.get('/v1/user/')
    return response.data
  } catch (error) {
    throw error
  }
}

export {
  createUser,
  authenticateUser,
  fetchUserPaymentCount,
  updateCurrency,
  forgotPin,
  fetchUserAccount,
  fetchUserActivity,
  fetchUserfeedExportFile,
  exportUserfeed,
  cancelAccount,
  fetchReferralInfo,
  fetchNumbers,
  fetchIdentities,
  saveNumber,
  deleteNumber,
  addNumber,
  setPrimiaryNumber,
  verifyNumberBySMS,
  verifyNumberByCall,
  verifyNumberWithRecivedCode,
  fetchUserServices
}



// WEBPACK FOOTER //
// ./src/api/user/index.js